import React, { useState, useEffect } from 'react';
import { Avatar, TextField, Button } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {
  CambiarClave,
  enviarMail,
  loginUsuario,
} from '../../actions/UsuariosAction';
import { withRouter } from 'react-router-dom';
import { useStateValue } from '../../contexto/store';
import Dialog from '@mui/material/Dialog';
import { Typography } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit">TILERIA CRM</Link> {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Login = (props) => {
  const theme = useTheme();
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [openDialog, setOpenDialog] = useState(false);
  const [usuario, setUsuario] = useState({
    Email: '',
    Password: '',
  });

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setUsuario((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

const loginUsuarioBoton = (e) => {
  e.preventDefault();

  if (usuario.Email === '' || usuario.Password === '') {
    dispatch({
      type: 'OPEN_SNACKBAR',
      openMensaje: {
        open: true,
        mensaje: 'Debe llenar todos los campos',
      },
    });
  } else {
    loginUsuario(usuario, dispatch)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.rolesUsuario.length > 0) {
            if (response.data.pantallasUsuario !== null) {
              window.localStorage.setItem(
                'token_seguridad',
                response.data.token
              );
              props.history.push('/');
            } else {
              dispatch({
                type: 'OPEN_SNACKBAR',
                openMensaje: {
                  open: true,
                  mensaje:
                    'El rol asignado a este usuario no tiene ninguna pantalla habilitada.',
                },
              });
            }
          } else {
            dispatch({
              type: 'OPEN_SNACKBAR',
              openMensaje: {
                open: true,
                mensaje:
                  'Usuario no tiene asignado un rol. Contacte al administrador.',
              },
            });
          }
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Credenciales incorrectas',
            },
          });
        }
      })
      .catch((error) => {
        console.error('Error en login:', error);

        const mensaje =
          error.response?.data?.mensaje ||
          (error.response?.status === 401
            ? 'Credenciales incorrectas'
            : 'Ocurrió un error al iniciar sesión');

        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: mensaje,
          },
        });
      });
  }
};

  const enviarClaveNueva = () => {
    let clave = '';
    let letras = [
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
      'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    ];
    let numeros = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let caracteres = ['!', '@', '#', '$', '%', '&', '*', '(', ')', '_'];
    const letraMayusRand = letras[
      Math.floor(Math.random() * letras.length)
    ].toUpperCase();
    const letraRand = letras[Math.floor(Math.random() * letras.length)];
    const numeroRand = numeros[Math.floor(Math.random() * numeros.length)];
    const caracterRand =
      caracteres[Math.floor(Math.random() * caracteres.length)];

    clave = letraMayusRand + letraRand + numeroRand + caracterRand;
    let objeto = {
      Email: usuario.Email,
      Password: clave,
    };

    CambiarClave(objeto).then((response) => {
      if (response.status === 200) {
        const objetoMail = {
          Email: objeto.Email,
          Subject: 'Clave provisoria de usuario ',
          Body:
            'Estimado usuario esta clave solo es provisoria asegurese de Cambiarla una vez ingrese al sistema Clave : ' +
            objeto.Password +
            ' ',
        };

        enviarMail(objetoMail).then((response) => {
          if (response.status === 200) {
            setOpenDialog(false);
          }
        });

        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje:
              'Se envio la contraseña provisoria a su correo electronico',
          },
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje:
              'Errores al intentar enviar la contraseña verifique que el correo enviado sea el registrado en el sistema',
          },
        });
      }
    });
  };

  useEffect(() => {
    localStorage.removeItem('token_seguridad');
    dispatch({
      type: 'SALIR_SESION',
      nuevoUsuario: null,
      autenticado: false,
    });
  }, [dispatch]);

  // return (
  //   <Grid container component="main" sx={{ height: '100vh' }}>
  //     <CssBaseline />

  //     {/* Grid para el formulario - IZQUIERDA */}
  //     <Grid 
  //       item 
  //       xs={12} 
  //       sm={8} 
  //       md={5} 
  //       component={Paper} 
  //       elevation={0}
  //       square
  //       sx={{
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           width: '100%',
  //           maxWidth: 450,
  //           px: 4,
  //           py: 6,
  //           display: 'flex',
  //           flexDirection: 'column',
  //           alignItems: 'center',
  //         }}
  //       >
  //         {/* Card contenedor del formulario */}
  //         <Paper
  //           elevation={8}
  //           sx={{
  //             width: '100%',
  //             p: 4,
  //             borderRadius: 3,
  //             backgroundColor: 'rgba(255, 255, 255, 0.95)',
  //             backdropFilter: 'blur(10px)',
  //           }}
  //         >
  //           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  //             <Avatar
  //               sx={{
  //                 mb: 2,
  //                 bgcolor: 'primary.main',
  //                 width: 70,
  //                 height: 70,
  //                 boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
  //               }}
  //             >
  //               <LockOutlinedIcon sx={{ fontSize: 35 }} />
  //             </Avatar>
              
  //             <Typography 
  //               component="h1" 
  //               variant="h4" 
  //               sx={{ 
  //                 fontWeight: 600, 
  //                 mb: 1,
  //                 color: 'primary.main',
  //               }}
  //             >
  //               Bienvenido
  //             </Typography>
              
  //             <Typography 
  //               variant="body2" 
  //               color="text.secondary"
  //               sx={{ mb: 3 }}
  //             >
  //               Ingresa tus credenciales para continuar
  //             </Typography>
  //           </Box>

  //           <Box
  //             component="form"
  //             noValidate
  //             sx={{ mt: 2 }}
  //           >
  //             <TextField
  //               variant="outlined"
  //               margin="normal"
  //               required
  //               fullWidth
  //               id="email"
  //               label="Correo Electrónico"
  //               name="Email"
  //               autoComplete="email"
  //               autoFocus
  //               value={usuario.Email}
  //               onChange={ingresarValoresMemoria}
  //               sx={{
  //                 '& .MuiOutlinedInput-root': {
  //                   borderRadius: 2,
  //                   '&:hover fieldset': {
  //                     borderColor: 'primary.main',
  //                   },
  //                 },
  //               }}
  //             />

  //             <TextField
  //               variant="outlined"
  //               margin="normal"
  //               required
  //               fullWidth
  //               name="Password"
  //               label="Contraseña"
  //               type="password"
  //               id="password"
  //               autoComplete="current-password"
  //               onChange={ingresarValoresMemoria}
  //               value={usuario.Password}
  //               sx={{
  //                 '& .MuiOutlinedInput-root': {
  //                   borderRadius: 2,
  //                   '&:hover fieldset': {
  //                     borderColor: 'primary.main',
  //                   },
  //                 },
  //               }}
  //             />

  //             <Button
  //               type="submit"
  //               fullWidth
  //               variant="contained"
  //               color="primary"
  //               size="large"
  //               onClick={loginUsuarioBoton}
  //               sx={{
  //                 mt: 3,
  //                 mb: 2,
  //                 py: 1.5,
  //                 borderRadius: 2,
  //                 textTransform: 'none',
  //                 fontSize: '1rem',
  //                 fontWeight: 600,
  //                 boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
  //                 '&:hover': {
  //                   boxShadow: '0 6px 20px rgba(0,118,255,0.5)',
  //                   transform: 'translateY(-2px)',
  //                 },
  //                 transition: 'all 0.3s ease',
  //               }}
  //             >
  //               Iniciar Sesión
  //             </Button>

  //             <Box sx={{ textAlign: 'center', mt: 2 }}>
  //               <Link
  //                 component="button"
  //                 type="button"
  //                 onClick={() => setOpenDialog(true)}
  //                 variant="body2"
  //                 sx={{
  //                   textDecoration: 'none',
  //                   color: 'primary.main',
  //                   fontWeight: 500,
  //                   '&:hover': {
  //                     textDecoration: 'underline',
  //                   },
  //                 }}
  //               >
  //                 ¿Olvidaste tu contraseña?
  //               </Link>
  //             </Box>
  //           </Box>
  //         </Paper>

  //         {/* Copyright fuera del card */}
  //         <Box mt={4}>
  //           <Copyright />
  //         </Box>
  //       </Box>

  //       {/* Dialog para recuperar contraseña */}
  //       <Dialog
  //         open={openDialog}
  //         onClose={() => setOpenDialog(false)}
  //         aria-labelledby="form-dialog-title"
  //         PaperProps={{
  //           sx: {
  //             borderRadius: 3,
  //             minWidth: { xs: '90%', sm: 400 },
  //           },
  //         }}
  //       >
  //         <DialogTitle 
  //           id="form-dialog-title"
  //           sx={{
  //             backgroundColor: 'primary.main',
  //             color: 'white',
  //             fontWeight: 600,
  //           }}
  //         >
  //           Recuperar Contraseña
  //         </DialogTitle>
  //         <DialogContent sx={{ mt: 2 }}>
  //           <DialogContentText component={'div'}>
  //             <Typography component={'div'} variant="body2" sx={{ mb: 2 }}>
  //               Te enviaremos una contraseña provisional a tu correo electrónico.
  //               Por favor, ingresa tu dirección de correo registrada.
  //             </Typography>
  //           </DialogContentText>
  //           <TextField
  //             label="Correo Electrónico"
  //             fullWidth
  //             name="Email"
  //             onChange={ingresarValoresMemoria}
  //             color="primary"
  //             autoFocus
  //             value={usuario.Email}
  //             sx={{
  //               '& .MuiOutlinedInput-root': {
  //                 borderRadius: 2,
  //               },
  //             }}
  //           />
  //         </DialogContent>
  //         <DialogActions sx={{ p: 2.5, gap: 1 }}>
  //           <Button 
  //             onClick={() => setOpenDialog(false)} 
  //             variant="outlined"
  //             sx={{
  //               borderRadius: 2,
  //               textTransform: 'none',
  //               px: 3,
  //             }}
  //           >
  //             Cancelar
  //           </Button>
  //           <Button 
  //             onClick={enviarClaveNueva} 
  //             variant="contained"
  //             sx={{
  //               borderRadius: 2,
  //               textTransform: 'none',
  //               px: 3,
  //             }}
  //           >
  //             Enviar
  //           </Button>
  //         </DialogActions>
  //       </Dialog>
  //     </Grid>

  //     {/* Grid para la imagen - DERECHA */}
  //     <Grid
  //       item
  //       xs={false}
  //       sm={4}
  //       md={7}
  //       sx={{
  //         position: 'relative',
  //         backgroundImage: `url(${require('../../assets/login.jpg')})`,
  //         backgroundRepeat: 'no-repeat',
  //         backgroundSize: 'cover',
  //         backgroundPosition: 'center',
  //         backgroundColor: theme.palette.mode === 'light'
  //           ? theme.palette.grey[200]
  //           : theme.palette.grey[800],
  //         minHeight: '100vh',
  //         display: { xs: 'none', sm: 'flex' },
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         '&::before': {
  //           content: '""',
  //           position: 'absolute',
  //           top: 0,
  //           right: 0,
  //           bottom: 0,
  //           left: 0,
  //           background: 'linear-gradient(135deg, rgba(0,118,255,0.7) 0%, rgba(0,77,168,0.8) 100%)',
  //         },
  //       }}
  //     >
  //       {/* Contenido sobre la imagen */}
  //       <Box
  //         sx={{
  //           position: 'relative',
  //           zIndex: 1,
  //           textAlign: 'center',
  //           color: 'white',
  //           px: 4,
  //         }}
  //       >
  //         <Typography 
  //           variant="h2" 
  //           sx={{ 
  //             fontWeight: 700, 
  //             mb: 2,
  //             textShadow: '0 2px 10px rgba(0,0,0,0.3)',
  //           }}
  //         >
  //           TILERIA CRM
  //         </Typography>
  //         <Typography 
  //           variant="h5" 
  //           sx={{ 
  //             fontWeight: 300,
  //             textShadow: '0 2px 10px rgba(0,0,0,0.3)',
  //           }}
  //         >
  //           Gestión integral para tu negocio
  //         </Typography>
  //       </Box>
  //     </Grid>
  //   </Grid>
  // );
  return (
    <Box
      component="main"
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        margin: 0,
        padding: 0,
      }}
    >
      <CssBaseline />

      {/* Contenedor para el formulario - IZQUIERDA */}
      <Grid
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #ffffffff 0%, #f5f7fa 100%)',
          height: '100vh',
          overflowY: 'auto',
          width: { xs: '100%', sm: '40%', md: '41.666%' },
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 450,
            px: 4,
            py: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* Card contenedor del formulario */}
          <Paper
            elevation={8}
            sx={{
              width: '100%',
              p: 4,
              borderRadius: 3,
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar
                sx={{
                  mb: 2,
                  bgcolor: 'primary.main',
                  width: 70,
                  height: 70,
                  boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
                }}
              >
                <LockOutlinedIcon sx={{ fontSize: 35 }} />
              </Avatar>
              
              <Typography 
                component="h1" 
                variant="h4" 
                sx={{ 
                  fontWeight: 600, 
                  mb: 1,
                  color: 'primary.main',
                }}
              >
                Bienvenido
              </Typography>
              
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ mb: 3 }}
              >
                Ingresa tus credenciales para continuar
              </Typography>
            </Box>

            <Box
              component="form"
              noValidate
              sx={{ mt: 2 }}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Correo Electrónico"
                name="Email"
                autoComplete="email"
                autoFocus
                value={usuario.Email}
                onChange={ingresarValoresMemoria}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    '&:hover fieldset': {
                      borderColor: 'primary.main',
                    },
                  },
                }}
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="Password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={ingresarValoresMemoria}
                value={usuario.Password}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    '&:hover fieldset': {
                      borderColor: 'primary.main',
                    },
                  },
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={loginUsuarioBoton}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
                  '&:hover': {
                    boxShadow: '0 6px 20px rgba(0,118,255,0.5)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Iniciar Sesión
              </Button>

              <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Link
                  component="button"
                  type="button"
                  onClick={() => setOpenDialog(true)}
                  variant="body2"
                  sx={{
                    textDecoration: 'none',
                    color: 'primary.main',
                    fontWeight: 500,
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </Box>
            </Box>
          </Paper>

          {/* Copyright fuera del card */}
          <Box mt={4}>
            <Copyright />
          </Box>
        </Box>

        {/* Dialog para recuperar contraseña */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            sx: {
              borderRadius: 3,
              minWidth: { xs: '90%', sm: 400 },
            },
          }}
        >
          <DialogTitle 
            id="form-dialog-title"
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              fontWeight: 600,
            }}
          >
            Recuperar Contraseña
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            <DialogContentText component={'div'}>
              <Typography component={'div'} variant="body2" sx={{ mb: 2 }}>
                Te enviaremos una contraseña provisional a tu correo electrónico.
                Por favor, ingresa tu dirección de correo registrada.
              </Typography>
            </DialogContentText>
            <TextField
              label="Correo Electrónico"
              fullWidth
              name="Email"
              onChange={ingresarValoresMemoria}
              color="primary"
              autoFocus
              value={usuario.Email}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2.5, gap: 1 }}>
            <Button 
              onClick={() => setOpenDialog(false)} 
              variant="outlined"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                px: 3,
              }}
            >
              Cancelar
            </Button>
            <Button 
              onClick={enviarClaveNueva} 
              variant="contained"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                px: 3,
              }}
            >
              Enviar
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>

      {/* Grid para la imagen - DERECHA */}
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${require('../../assets/login.jpg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          width: { xs: '0%', sm: '60%', md: '58.334%' },
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            // background: 'linear-gradient(135deg, rgba(0,118,255,0.7) 0%, rgba(0,77,168,0.8) 100%)',
            zIndex: 0,
          },
        }}
      >
        {/* Contenido sobre la imagen */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            textAlign: 'center',
            color: 'white',
            px: 4,
          }}
        >
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 700, 
              mb: 2,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            TILERIA CRM
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 300,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Gestión integral para tu negocio
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default withRouter(Login);